// Back-in-stock sign-up box (snippets/back-in-stock.liquid).
// Shows the box only while the selected option is sold out and keeps the option's tag up to date. The form is sent
// the normal way so Shopify's spam check (hCaptcha) can run on it; Shopify then reloads the product page, and the
// thank-you or error message is shown when that reload came from this box (not, say, the footer newsletter form).

const PENDING_KEY = 'allett:back-in-stock-pending';

const remember = (value) => {
  try {
    value ? sessionStorage.setItem(PENDING_KEY, value) : sessionStorage.removeItem(PENDING_KEY);
  } catch (error) {
    // Storage can be blocked (private windows); the sign-up still works, only the message after the reload is skipped.
  }
};

const recall = () => {
  try {
    return sessionStorage.getItem(PENDING_KEY);
  } catch (error) {
    return null;
  }
};

class BackInStockForm extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.form = this.querySelector('form');
    this.tagsInput = this.form.querySelector('[name="contact[tags]"]');

    document.addEventListener('variant:change', this.onVariantChange.bind(this), { signal: this.abortController.signal });
    this.form.addEventListener('submit', () => remember(this.tagsInput.value), { signal: this.abortController.signal });

    // Page reloaded after a sign-up from this box: show how it went.
    if (recall()) {
      remember(null);

      if (this.querySelector('[data-bis-posted]') || new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
        this.showResult('success');
      } else if (this.querySelector('[data-bis-errors]')) {
        this.showResult('error');
      }
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onVariantChange(event) {
    if (event.target.getAttribute?.('id') !== this.getAttribute('product-form')) {
      return;
    }

    const variant = event.detail.variant;
    this.hidden = !variant?.id || variant.available;

    if (variant?.id) {
      this.tagsInput.value = `back-in-stock, bis-${variant.id}, bisp-${this.getAttribute('product-handle')}`;
    }

    this.showState('form');
  }

  showResult(state) {
    this.hidden = false;
    this.showState(state);
    this.scrollIntoView({ block: 'center' });
  }

  showState(state) {
    this.querySelector('[data-bis-fields]').hidden = state === 'success';
    this.querySelector('[data-bis-success]').hidden = state !== 'success';
    this.querySelector('[data-bis-error]').hidden = state !== 'error';
  }
}

if (!window.customElements.get('back-in-stock-form')) {
  window.customElements.define('back-in-stock-form', BackInStockForm);
}
